<template>
  <div class="py-4 container-fluid">
    <div class="mt-4 row">
      <div class="col-12 mb-10">
        <add-admin />
      </div>
    </div>
  </div>
</template>

<script>
// import AuthorsTable from "./components/AuthorsTable.vue";
import AddAdmin from "./components/AddAdmin.vue";

export default {
  name: "Add Admin",
  components: {
    // AuthorsTable,
    AddAdmin
  },
};
</script>
